import styled from "styled-components";

export const SpinnerContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
`;

export const CardView = styled.div`
  position: relative;
  cursor: pointer;
  width: 200px;
  height: ${({ hasFirstField, hasSecondField }) => {
    if (hasFirstField && hasSecondField) {
      return "165px";
    }
    if (hasFirstField || hasSecondField) {
      return "150px";
    }
    return "130px";
  }};
  box-sizing: border-box;
  padding: 20px;

  background-color: ${({ isHoveringOver, theme }) =>
    isHoveringOver ? theme.people.backgroundHover : theme.background};
  border-radius: ${({ borderRadius }) =>
    `${borderRadius !== undefined ? borderRadius : 3}px`};
  box-shadow: ${({ theme }) => theme.orgchart.boxShadow};
  border: ${({ isSelected }) =>
    `1px solid ${isSelected ? "#4C9AFF" : "transparent"}`};

  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 8px;

  transition: background-color 100ms linear;

  .delete-action {
    opacity: 0;
    transition: opacity 100ms linear;
  }

  &:hover {
    .delete-action {
      opacity: 1;
    }
  }
`;

export const ListView = styled.div`
  position: relative;

  width: 320px;
  height: 100px;
  box-sizing: border-box;
  padding: 20px;
  border-radius: ${({ borderRadius }) =>
    `${borderRadius !== undefined ? borderRadius : 3}px`};
  border: ${({ isSelected }) =>
    `1px solid ${isSelected ? "#4C9AFF" : "transparent"}`};
  background-color: ${({ isHoveringOver, theme }) =>
    isHoveringOver ? theme.orgchart.backgroundHover : theme.background};
  box-shadow: ${({ theme }) => theme.orgchart.boxShadow};

  display: flex;
  align-items: center;
  column-gap: 12px;

  .delete-action {
    opacity: 0;
    transition: opacity 100ms linear;
  }

  &:hover {
    .delete-action {
      opacity: 1;
    }
  }
`;

export const UserImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 48px;

  margin-bottom: 4px;
  object-fit: cover;
`;

export const Name = styled.span`
  text-align: center;
  color: ${({ color }) => color};
  font-size: 16px;
  min-height: 18px;
  font-weight: 500;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Info = styled.h2`
  all: unset;
  color: ${({ color }) => color};
  text-align: center;
  font-weight: 500;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TextColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: grid;
  place-content: center;

  cursor: pointer;

  position: absolute;

  ${({ position }) => {
    if (position === "bottom") {
      return `
        left: calc(50% - 12px);
        bottom: -12px;
      `;
    }
    if (position === "right") {
      return `
        top: 8px;
        right: -12px;
      `;
    }
  }}

  svg, circle, path {
    transition: color 100ms linear, fill 100ms linear;
  }

  circle {
    fill: ${({ theme }) => theme.orgchart.minusPlusColor};
  }

  &:hover {
    .delete-action {
      circle {
        fill: #ff5630;
      }
      path {
        fill: #fff;
      }
    }

    svg {
      color: #0065ff !important;
      fill: #fff !important;
    }
  }
`;

export const PeopleSubtitle = styled.h2`
  all: unset;
  color: ${({ color }) => color};
  text-align: center;
  font-size: ${({ isTemplate }) => (isTemplate ? "10px" : "14px")};

  font-style: normal;
  font-weight: 500;
  line-height: ${({ isTemplate }) => (isTemplate ? "12px" : "19px")};
`;

export const Label = styled.div`
  border-radius: 100px;
  background: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.border.black10};
  display: flex;
  padding: ${({ isTemplate }) =>
    isTemplate ? " 3.699px 7.399px" : "5px 10px"};

  justify-content: center;
  align-items: center;
  width: fit-content;
  color: ${({ color, theme }) => color || theme.text.title};
  font-size: ${({ isTemplate }) => (isTemplate ? "9px" : "12px")};

  font-style: normal;
  font-weight: 500;
  line-height: ${({ isTemplate }) => (isTemplate ? "9px" : "16px")};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
`;
